import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
faCircleO, faCheckCircle, faCircleArrowRight
} from "@fortawesome/pro-light-svg-icons";

const items = [
  {
    icon: <FontAwesomeIcon  icon={faCircleO} size="xl" color='silver'/>,
    title: 'Welcome',
    description:
      '',
  },
  {
    icon: <FontAwesomeIcon  icon={faCircleO} size="xl" color='silver'/>,
    title: 'Validate Sentinel Subscription',
    description:
      'Step one is validating your subscription id. Please make sure you have this to hand so we can validate our connection to your worksspace.',
  },
  {
    icon: <FontAwesomeIcon  icon={faCircleO} size="xl" color='silver'/>,
    title: 'Company Information',
    description:
      'Please enter your companies details.',
  },
  {
    icon: <FontAwesomeIcon  icon={faCircleO} size="xl" color='silver'/>,
    title: 'Your Details',
    description:
      'We will need a few details about yourself.',
  },
  {
    icon: <FontAwesomeIcon  icon={faCircleO} size="xl" color='silver'/>,
    title: 'All Done!',
    description:
      '',
  },
];

interface SignupContentProps {
  currentStage : number;
}

export const SignupStages : React.FC<SignupContentProps> = (props) => {
  return (
    <Stack
      sx={{ flexDirection: 'column', alignSelf: 'center', gap: 4, maxWidth: 450 }}
    >
      
      {items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          
          {props.currentStage > index  ? <FontAwesomeIcon  icon={faCheckCircle} size="xl" color='orange'/> : 
            props.currentStage === index ? <FontAwesomeIcon  icon={faCircleArrowRight} size="xl" color='green'/> : <FontAwesomeIcon  icon={faCircleO} size="xl" color='silver'/>}
          
          <div>
            <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
}